import React, { memo, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import NotLiveRoute from 'react-live-route'
const LiveRoute = withRouter(NotLiveRoute)
function DynamicRouter({ route, cacheRoute, index }) {
  const renderComponent = useCallback((props) => {
    const Component = route.component
    return (
      <Component
        {...props}
        currMenu={route.dynamicDetail?.parentRoute || route}
        dynamicDetail={route.dynamicDetail}
      />
    )
  }, [route])

  return (
    <LiveRoute
      key={route.key}
      exact
      path={`/${route.key}`}
      alwaysLive={true}
      render={renderComponent}
      forceUnmount={() => {
        const isFind = cacheRoute.find((c) => c.cacheKey == route.key)
        return !isFind
      }}
    />
  )
}

export default memo(DynamicRouter)
